<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="900"
    scrollable
  >
    <v-card
      tile
      min-height="350"
      :loading="!invitation"
    >
      <v-card-title
        class="primary font-weight-medium grey--text pt-1 pb-2 px-3"
      >
        Datos de la invitación | Checkout
      </v-card-title>
      <v-card-subtitle class="primary pb-2 px-3">
        Complete o consulte los datos de la invitación
      </v-card-subtitle>
      <v-card-text class="px-0">
        <v-container v-if="invitation && dialog" fluid>
          <v-row>
            <v-col cols="12" sm="8" class="pb-0 mb-0">
              <v-row>
                <v-col cols="12">
                  <input-component
                    v-model="invitation.type_invitation.name"
                    :v="{}"
                    :errors="[]"
                    :label="'Tipo de invitación'"
                    :disabled="true"
                  />
                </v-col>
                <v-col v-if="invitation.property" cols="12">
                  <input-component
                    v-model="invitation.property"
                    :v="{}"
                    :errors="[]"
                    :label="'Propiedad a visitar'"
                    :disabled="true"
                  />
                </v-col>
                <v-col v-if="invitation.venue.name" cols="12">
                  <input-component
                    v-model="invitation.venue.name"
                    :v="{}"
                    :errors="[]"
                    :label="'Propiedad a visitar'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="8">
                  <input-component
                    v-model="invitation.invitated.name"
                    :v="{}"
                    :errors="[]"
                    :label="'Nombre del invitado'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="4">
                  <input-component
                    v-model="invitation.invitated.type_identification.name"
                    :v="{}"
                    :errors="[]"
                    :label="'Tipo de documento'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="6">
                  <masked-input-component
                    v-model="invitation.invitated.identification"
                    :v="{}"
                    :errors="[]"
                    :label="'Número de documento'"
                    :mask="identificationMask(invitation.invitated.type_identification.id)"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="4">
                  <select-component
                    v-model="checkin.total_companions"
                    :v="{}"
                    :errors="[]"
                    :label="'Acompañantes'"
                    :items="items"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="2" align="end" class="pl-0">
                  <v-btn
                    outlined
                    color="light-blue lighten-3"
                    @click="showCompanions = !showCompanions"
                    height="40"
                  >
                    ...
                  </v-btn>
                </v-col>
                <v-expand-transition>
                <v-col cols="12" v-if="showCompanions">
                  <v-card class="elevation-3">
                    <v-card-title class="font-weight-medium grey--text pt-1 pb-2 px-3">
                      Acompañantes
                    </v-card-title>
                    <v-card-text>
                      <v-row v-for="(item, i) in checkin.persons" :key="i">
                        <v-col cols="5" class="px-1">
                          <input-component
                            v-model="checkin.persons[i].name"
                            :v="{}"
                            :errors="[]"
                            :label="'Nombre completo'"
                            :disabled="true"
                          />
                        </v-col>
                        <v-col cols="3" class="px-1">
                          <select-component
                            v-model="checkin.persons[i].type_identification"
                            :v="{}"
                            :errors="[]"
                            :label="'Tipo de identificación'"
                            :items="identificationTypes"
                            :translate="true"
                            :disabled="true"
                          />
                        </v-col>
                        <v-col cols="4" class="px-1">
                          <masked-input-component
                            v-model="checkin.persons[i].identification"
                            :v="{}"
                            :errors="[]"
                            :label="'No. de identificacion'"
                            :mask="identificationMask(checkin.persons[i].type_identification)"
                            :disabled="true"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                </v-expand-transition>
                <v-col cols="6">
                  <select-component
                    v-model="checkin.transport.medio"
                    :v="{}"
                    :errors="[]"
                    :label="'Tipo de transporte'"
                    :items="transportTypes"
                    :translate="true"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="6">
                  <select-component
                    v-model="checkin.transport.color"
                    :v="{}"
                    :errors="[]"
                    :label="'Color transporte'"
                    :items="transportColors"
                    :translate="true"
                    :disabled="true"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="4">
              <v-row>
                <v-col cols="12">
                  <textarea-component
                    v-model="invitation.note"
                    :v="{}"
                    :errors="[]"
                    :label="'Nota del propietario'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="12">
                  <textarea-component
                    v-model="checkin.note"
                    :v="{}"
                    :errors="[]"
                    :label="'Observaciones al check-in'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="12">
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-1">
              <v-row>
                <v-col cols="2" class="pt-0">
                  <input-component
                    v-model="checkin.transport.plate"
                    :v="{}"
                    :errors="[]"
                    :label="'Número de placa'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="2" class="pt-0">
                  <input-component
                    :value="dateForDisplay(invitation.date_entry)"
                    :v="{}"
                    :errors="[]"
                    :label="'F. llegada'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="2" class="pt-0">
                  <input-component
                    :value="dateForDisplay(invitation.date_out)"
                    :v="{}"
                    :errors="[]"
                    :label="'F. salida'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="3" class="pt-0">
                  <input-component
                    :value="dateTimeForDisplay(checkin.date)"
                    :v="{}"
                    :errors="[]"
                    :label="'F/H Check-in'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="3" class="pt-0">
                  <input-component
                    v-model="checkin.user"
                    :v="{}"
                    :errors="[]"
                    :label="'Usuario Check-in'"
                    :disabled="true"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="invitation && dialog">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="grey"
          @click="closeDialog"
        >
          Cancelar
        </v-btn>
        <v-btn
          depressed
          color="error"
          @click="makeCheckout"
          :loading="sending"
        >
          Check-out
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import types from '@/types';
import InputComponent from '@/components/forms/InputComponent';
import MaskedInputComponent from '@/components/forms/MaskedInputComponent';
import SelectComponent from '@/components/forms/SelectComponent';
import TextareaComponent from '@/components/forms/TextareaComponent';
import PropertyService from '@/services/PropertyService';
import moment from 'moment';

export default {
  props: [
    'value',
    'invitationId',
  ],

  components: {
    InputComponent,
    MaskedInputComponent,
    SelectComponent,
    TextareaComponent,
  },

  data() {
    return {
      sending: false,
      items: [
        0, 1, 2, 3, 4,
      ],
      showCompanions: false,
      propertyService: PropertyService,
    };
  },

  watch: {
    dialog(value) {
      if (value) {
        this[types.GET_INVITATION_CHECKOUT](this.invitationId);
      }
    },
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    ...mapState(
      `${types.INVITATION}`, [
        'invitation',
        'invitationTypes',
        'identificationTypes',
        'transportTypes',
        'transportColors',
      ],
    ),
    checkin() {
      return this.invitation.checkin ? this.invitation.checkin : { guest: {}, transport: {} };
    },
  },

  methods: {
    ...mapMutations(
      `${types.APP}`, [
        types.SHOW_BUSY,
        types.HIDE_BUSY,
        types.SHOW_SUCCESS,
        types.SHOW_ERROR,
      ],
    ),
    ...mapMutations(
      `${types.INVITATION}`, [
        types.SET_INVITATION,
      ],
    ),
    ...mapActions({
      [types.GET_INVITATION_CHECKOUT]: `${types.INVITATION}/${types.GET_INVITATION_CHECKOUT}`,
      [types.CHECK_OUT]: `${types.INVITATION}/${types.CHECK_OUT}`,
    }),
    closeDialog() {
      this.dialog = false;
      this.showCompanions = false;
      setTimeout(() => {
        this[types.SET_INVITATION]();
      }, 500);
    },
    makeCheckout() {
      this.sending = true;
      this[types.CHECK_OUT](this.invitationId)
        .then(() => {
          this[types.SHOW_SUCCESS]('Check-out realizado.');
          this.closeDialog();
        })
        .catch(() => {
          this[types.SHOW_ERROR]('Hubo un error realizando el check-out.');
        })
        .finally(() => {
          this.sending = false;
        });
    },
    dateForDisplay(date) {
      return date ? moment(date).format('D/M/YYYY') : '';
    },
    dateTimeForDisplay(date) {
      return date ? moment(date).format('D/M/YYYY HH:MM') : '';
    },
    errorsPersons(idx, field) {
      const errors = [];
      if (!this.$v.checkin.persons.$each[idx][field].$dirty) {
        return errors;
      }
      if (!this.$v.checkin.persons.$each[idx][field].required) {
        errors.push('This field is required.');
      }
      return errors;
    },
    identificationMask(identificationTypeId) {
      const identificationType = this.identificationTypes.find(
        (item) => item.id === identificationTypeId,
      );
      if (identificationType && identificationType.name.toLowerCase() === 'cedula') {
        return '###-#######-#';
      }
      return 'XXXXXXXXXXXXX';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CheckoutComponent.vue